import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
  RECAPTCHA_SETTINGS
} from 'ng-recaptcha';
import { environment } from '../../environments/environment';
import { HeaderI18nComponent } from '../shared-resources/base-i18n/component/i18n.component';
import { ZORRO_MODULES } from './../shared-resources/zorro-modules';
import { AccountActivationComponent } from './account-activation/account-activation.component';
import { AdminResetPasswordComponent } from './admin-reset-password/admin-reset-password.component';
import { FooterComponent } from './footer/footer.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { HeaderDefaultCompanyComponent } from './header/components/default-company.component';
import { HeaderFullScreenComponent } from './header/components/fullscreen.component';
import { HeaderIconComponent } from './header/components/icon.component';
import { HeaderNotifyComponent } from './header/components/notify.component';
import { HeaderSearchComponent } from './header/components/search.component';
import { HeaderStorageComponent } from './header/components/storage.component';
import { HeaderTaskComponent } from './header/components/task.component';
import { HeaderUserComponent } from './header/components/user.component';
import { HeaderComponent } from './header/header.component';
import { LayoutDefaultComponent } from './layout-default/layout-default.component';
import { LayoutHomeComponent } from './layout-home/layout-home.component';
import { LoginAdminComponent } from './login/login-admin/login-admin.component';
import { LoginEnduserComponent } from './login/login-enduser/login-enduser.component';
import { LoginComponent } from './login/login.component';
import { MobileBypassComponent } from './mobile-bypass/mobile-bypass.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AccountActivationService } from './services/account-activation.service';
import { AuthGuardService } from './services/auth-guard.service';
import { DeactivateGuardService } from './services/deactivate-guard.service';
import { DefaultCompanyService } from './services/default-company.service';
import { ForgotPassService } from './services/forgot-password';
import { LoginService } from './services/login.service';
import { LogoutService } from './services/logout.service';
import { ResetPasswordService } from './services/reset-password';
import { NotifyService } from './services/notify.service';
import { SignupService } from './services/signup.service';
import { SignupComponent } from './signup/signup.component';
import { BaseSharedModule } from 'base-shared';
import { FtaAdvisorComponent } from './fta-advisor/fta-advisor.component';
import { IntelligenceSuiteComponent } from './login/intelligence-suite/intelligence-suite.component';
import { InventoryUiComponent } from './login/inventory-ui/inventory-ui.component';
import { VerifyOtpComponent } from './verify-otp/verify-otp.component';
import { BuildDetailsComponent, BuildInfoButtonComponent } from '../shared-resources/components';
import { SharedModule } from '../shared-resources/shared.module';

const COMPONENTS = [
  BuildDetailsComponent,
  BuildInfoButtonComponent,
  LayoutDefaultComponent,
  LayoutHomeComponent,
  HeaderSearchComponent,
  HeaderComponent,
  HeaderUserComponent,
  HeaderNotifyComponent,
  HeaderIconComponent,
  HeaderTaskComponent,
  HeaderStorageComponent,
  HeaderFullScreenComponent,
  HeaderDefaultCompanyComponent,
  LoginComponent,
  ForgotPasswordComponent,
  FooterComponent,
  SignupComponent,
  ForgotPasswordComponent,
  AccountActivationComponent,
  LoginEnduserComponent,
  LoginAdminComponent,
  ResetPasswordComponent,
  AdminResetPasswordComponent,
  MobileBypassComponent,
  HeaderI18nComponent,
  FtaAdvisorComponent,
  IntelligenceSuiteComponent,
  InventoryUiComponent,
  VerifyOtpComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    BaseSharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    TranslateModule.forChild(),
    ...ZORRO_MODULES,
  ],
  exports: [...COMPONENTS],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.reCaptchaKey,
      } as RecaptchaSettings
    },
    LoginService,
    SignupService,
    ForgotPassService,
    AccountActivationService,
    AuthGuardService,
    DeactivateGuardService,
    ResetPasswordService,
    LogoutService,
    DefaultCompanyService,
  ],
})
export class LayoutModule {}
